import React, { useState } from "react";
import { bmLogin } from "./bmClient";
import { bmColors } from "./bmStyles";

// Matches the staff sign-in screen's look. That screen uses hardcoded hexes
// rather than the palette, so those literals are mirrored here via bmColors
// rather than reaching for colors.darkGrey, which is a different blue.
export function BMLogin({ onSignedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!username.trim() || !password.trim()) {
      setError("Please enter your username and password.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const profile = await bmLogin(username, password);
      onSignedIn(profile);
    } catch (e) {
      if (e.code === "not-a-manager") {
        // Signed in fine, but /api/bm/me/ refused — either a staff account or
        // a manager whose access has been revoked. Said plainly rather than
        // "invalid password", which would send them hunting for the wrong
        // problem.
        setError(
          "That account does not have building manager access. If your access was recently removed, contact Standard Fire Protection."
        );
      } else {
        setError("Invalid username or password.");
      }
      setLoading(false);
    }
  };

  const field = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
    fontSize: "14px",
    boxSizing: "border-box",
  };

  const fieldLabel = {
    fontSize: "12px",
    fontWeight: "600",
    color: "#666",
    textTransform: "uppercase",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: bmColors.loginBg,
        padding: "16px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "40px 32px",
          width: "100%",
          maxWidth: "360px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
          boxSizing: "border-box",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ fontSize: "44px" }}>🏢</div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "#2c3e50",
              marginTop: "8px",
            }}
          >
            Building Manager Portal
          </div>
          <div style={{ fontSize: "13px", color: "#999", marginTop: "4px" }}>
            Standard Fire Protection
          </div>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label style={fieldLabel}>Username</label>
          <input
            style={field}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder="Username"
            autoFocus
            autoComplete="username"
          />
        </div>

        <div style={{ marginBottom: "24px" }}>
          <label style={fieldLabel}>Password</label>
          <input
            style={field}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder="Password"
            autoComplete="current-password"
          />
        </div>

        {error && (
          <div
            style={{
              color: "#c0392b",
              fontSize: "13px",
              marginBottom: "16px",
              textAlign: "center",
              lineHeight: "1.5",
            }}
          >
            {error}
          </div>
        )}

        <button
          onClick={submit}
          disabled={loading}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#c0392b",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "15px",
            fontWeight: "600",
            cursor: loading ? "default" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </div>
    </div>
  );
}
